import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=bb8d21a6&scoped=true"
import script from "./Success.vue?vue&type=script&lang=js"
export * from "./Success.vue?vue&type=script&lang=js"
import style0 from "./Success.vue?vue&type=style&index=0&id=bb8d21a6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8d21a6",
  null
  
)

/* custom blocks */
import block0 from "./Success.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/checkout-webapp-v2/checkout-webapp-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb8d21a6')) {
      api.createRecord('bb8d21a6', component.options)
    } else {
      api.reload('bb8d21a6', component.options)
    }
    module.hot.accept("./Success.vue?vue&type=template&id=bb8d21a6&scoped=true", function () {
      api.rerender('bb8d21a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/success/Success.vue"
export default component.exports